<template>
  <div class="section-card">
    <div class="section-header">
      <p class="section-title">Customer Detail</p>
    </div>
    <v-divider></v-divider>
    <div class="detail-grid">
      <div
        v-for="item in items"
        :key="item.label"
        class="detail-item"
      >
        <div class="detail-icon icon-bg">
          <v-icon size="16">{{ item.icon }}</v-icon>
        </div>
        <div>
          <p class="detail-label">{{ item.label }}</p>
          <p class="detail-value">{{ item.value }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type DetailItem = {
  icon: string;
  label: string;
  value: string;
};

withDefaults(
  defineProps<{
    items?: DetailItem[];
  }>(),
  {
    items: () => [],
  },
);
</script>

<style scoped>
.section-card {
  background: #fff;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.section-title {
  margin: 0;
  font-size: var(--font-size-default);
  letter-spacing: 0.1em;
  text-transform: capitalize;
  color: var(--color-title);
  font-weight: 700;
}
.detail-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.detail-icon {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
}

.detail-label {
  margin: 0;
  font-size: var(--font-size-default);
  color: var(--color-title);
  font-weight: 600;
}

.detail-value {
   margin: 2px 0;
  font-size: var(--font-size-default);
  color: var(--color-title);
}
</style>
